module.exports = __webpack_public_path__ + "static/02-ca4a23beb943add05b5335cc948d2472.jpg";